// extracted by mini-css-extract-plugin
export var content = "_pg-1";
export var noScroll = "_pg-3";
export var paper = "_pg-0";
export var scrollable = "_pg-2";